/**
 * Simülasyon sayfası — son yayınlanan planı düzenleyip modele
 * değerlendirtme, taslak olarak saklama ve canlıya alma ekranı.
 *
 * Sayfa yalnız kabuk işini yapar (son gezilen yolu hatırlatır); ekranın
 * tamamı `Components/Simulation` altında.
 */
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SimulasyonEkrani from "../Components/Simulation/SimulasyonEkrani";
import TableContext from "../Context/TablePosition";

const SimulasyonPage = () => {
  const { setCurrentUrl } = useContext(TableContext);
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("urlpaintshop", location.pathname);
    setCurrentUrl(localStorage.getItem("urlpaintshop"));
  }, [location.pathname, setCurrentUrl]);

  return <SimulasyonEkrani />;
};

export default SimulasyonPage;
